// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__38DVA","col":"CardReaderDesc_col__1yXTe","label":"CardReaderDesc_label__1QcfZ"};